import React, { Component } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import DatePicker from "react-datepicker";
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import 'react-day-picker/lib/style.css';
import PlusMinusNumber from '../../../ui/PlusMinusNumber';
import ToolTip from '../../../ui/ToolTip';
import { updateFormData, setListing, updateListing } from '../actions';
import { ListingPricingSchema } from '../validation';
import { populateListingFromFormData } from '../helpers';
import { addDaysToDate, subtractDaysFromDate } from '../../../../constants/util';
import DiscountModal from '../components/DiscountModal';
import ListingDiscountComponent from '../components/ListingDiscountComponent';
import { MAGIC_NUMBER } from '../../../../constants/magicNumbers';
import { removeDiscount, submitDiscount } from './listingFormDiscounts';
import { fixDateTimeMobileIssue } from '../../../checkInCheckoutPicker/checkInCheckOutPicker';

export const extendedStayToolTipMessage = `Provide extended stay base rates (for stays that are greater than ` +
  `${MAGIC_NUMBER.EXTENDED_STAY_MIN_DURATION} nights) and per your defined date range. ` +
  `Base extended stay rates will be reflected when a renter chooses ${MAGIC_NUMBER.EXTENDED_STAY_MIN_DURATION}+ nights within your selected date range.`;

const mapStateToProps = state => ({
  listing: state.Listing,
  user: state.Dashboard.user
});

const cssFormControl = "form-control";
const cssErrorInput = "error-input";
class ListingFormPricing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
      discountModalOpen: false,
      editingDiscount: null,
    }

    const workflow = this.props.workflow ? this.props.workflow : 'forms';
    this.nextPage = `/${this.props.parent}/listing/${workflow}/addOns`;
    this.prevPage = `/${this.props.parent}/listing/${workflow}/photosOrder`;

    this.openDiscountModal = this.openDiscountModal.bind(this);
    this.closeDiscountModal = this.closeDiscountModal.bind(this);

    this.renderExtraPricing = this.renderExtraPricing.bind(this);
  }

  componentDidMount = () => {
    fixDateTimeMobileIssue();
  }

  openDiscountModal(discount) {
    if (!discount)
      discount = null;
    this.setState({ discountModalOpen: true, editingDiscount: discount })
  }
  closeDiscountModal() { this.setState({ discountModalOpen: false, editingDiscount: null }) }

  saveListing = (values, pathAfterSave) => {
    this.setState({ isSubmitting: true });
    const workflow = this.props.workflow ? this.props.workflow : 'forms';
    let { dispatch, history, listing, step } = this.props;
    if (values.lastCompleted < step) { values.lastCompleted = step; }

    setTimeout(() => {
      dispatch(updateFormData(values)); // not needed?
      let updatedData = populateListingFromFormData(values);
      if (!updatedData._id) { updatedData._id = listing.listingData._id; }
      dispatch(setListing(updatedData));
      dispatch(updateListing()).then(() => {
        dispatch(setListing(updatedData));
        if (workflow === 'edit') history.goBack();
        else history.push(pathAfterSave);
      })
    }, 500);
  }

  submitAndBack = (values) => {
    this.saveListing(values, this.prevPage)
  }

  onSubmit = (values, { setSubmitting }) => {
    setSubmitting(false)
    this.saveListing(values, this.nextPage)
  }

  submitAndExit = (values) => {
    this.saveListing(values, `/${this.props.parent}/manage-listings`)
  }

  exit = (values, { setSubmitting }) => {
    this.setState({ isSubmitting: true })
    let { dispatch } = this.props
    let { history } = this.props
    let updatedData = populateListingFromFormData(values);
    setTimeout(() => {
      setSubmitting(false)
      dispatch(setListing(updatedData))
      dispatch(updateListing())
      history.push(`/${this.props.parent}/manage-listings?view=ma`)
    }, 1000)
  }

  numberChange = (form, field, num) => {
    let newForm = form.values;
    let newVal = newForm["pricing"]["minNightStay"] + num
    newVal = newVal >= 1 ? newVal : 1;
    newForm["pricing"]["minNightStay"] = newVal;
    this.props.dispatch(updateFormData(newForm));
  }

  renderExtraPricing = (
    info, title, feeTitle, toolTipMessage,
    checkboxName, fromDateName, toDateName, valueName,
    isFromDateError, isToDateError, isValueError,
    minDateRange,
    handleChange, setFieldValue,
    filterDate
  ) => {

    const getValidDateInFuture = (dateToCheck, filterDate) => {
      let validDate = dateToCheck;
      if (!filterDate)
        return validDate;

      while (!filterDate(validDate))
        validDate = addDaysToDate(validDate, 1);

      return validDate;
    }

    return (
      <div>
        <div className="fieldgroup row pricing-checkbox">
          <label className="col-6 pricing-col">{title}
            <ToolTip position="right" message={toolTipMessage}>
              <i className="far fa-question-circle"></i></ToolTip>
          </label>
          <Field
            name={checkboxName}
            type="checkbox"
            className={cssFormControl}
            checked={info.enabled}
            onChange={e => {
              handleChange(e);
              setFieldValue(fromDateName, null);
              setFieldValue(toDateName, null);
              setFieldValue(valueName, null);

              setTimeout(() => {
                fixDateTimeMobileIssue();
              }, 25);
            }}
          />
        </div>
        <div className="row date-main-row">
          {
            !!info.enabled &&
            <div className="fieldgroup row pricing-date-row">
              <label className="col-6">Start Date:
                {/* <ToolTip position="right" message={priceToolTipMessage}>
                        <i className="far fa-question-circle"></i></ToolTip> */}
              </label>
              <DatePicker
                name={fromDateName}
                selected={!!info.from ? new Date(info.from) : undefined}
                dateFormat={MAGIC_NUMBER.CHECK_IN_DATE_FORMAT}
                minDate={getValidDateInFuture(new Date(), filterDate)}
                maxDate={!!info.to ?
                  subtractDaysFromDate(new Date(info.to), minDateRange) : undefined}
                onChange={value => {
                  setFieldValue(fromDateName, value.toISOString())
                }}
                filterDate={filterDate}
                closeOnScroll
                showMonthDropdown
                onChangeRaw={e => e.preventDefault()}
                showYearDropdown
                dropdownMode="select"
                placeholderText="Add Date"
                className={`${cssFormControl} ` +
                  (isFromDateError ? cssErrorInput : '')}
              />
              <ErrorMessage name={fromDateName} component="div" className="error-message col-12" />
            </div>
          }
          {
            !!info.enabled &&
            <div className="fieldgroup row pricing-date-row right-row-date">
              <label className="col-6">End Date:
                {/* <ToolTip position="right" message={priceToolTipMessage}>
                        <i className="far fa-question-circle"></i></ToolTip> */}
              </label>
              <DatePicker
                name={toDateName}
                selected={!!info.to ? new Date(info.to) : undefined}
                dateFormat={MAGIC_NUMBER.CHECK_IN_DATE_FORMAT}
                minDate={getValidDateInFuture(addDaysToDate(!!info.from ? new Date(info.from) : new Date(), minDateRange), filterDate)}
                onChange={value => {
                  setFieldValue(toDateName, value.toISOString())
                }}
                filterDate={filterDate}
                closeOnScroll
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                placeholderText="Add Date"
                onChangeRaw={e => e.preventDefault()}
                className={`${cssFormControl} ` +
                  (isToDateError ? cssErrorInput : '')}
              />
              <ErrorMessage name={toDateName} component="div" className="error-message col-12" />
            </div>
          }
        </div>
        {
          !!info.enabled &&
          <div className="fieldgroup row">
            <label className="col-6">{feeTitle}:
              {/* <ToolTip position="right" message={priceToolTipMessage}>
                        <i className="far fa-question-circle"></i></ToolTip> */}
            </label>
            <span className="dollar-field col-6">
              <Field
                name={valueName}
                type="number"
                className={`${cssFormControl} ` +
                  (isValueError ? cssErrorInput : '')}
              />
            </span>
            <ErrorMessage name={valueName} component="div" className="error-message col-12" />
          </div>
        }
      </div >
    )
  }

  render() {
    const { discountModalOpen, editingDiscount } = this.state;
    const listing = this.props.listing.formData;
    const priceToolTipMessage = "Your nightly base fee will be shown to potential renters. You can manage cost per night in the next step.";
    const depositToolTipMessage = "To protect against damages to your property, this amount will be held from renters prior to check in. " +
      "If damages are present after check out, you may be entitled to collect all or a portion of the damage deposit. "
      + "A minimum of $20 is required.";
    const submitButtonText = this.props.exit ? 'Save' : 'Next';

    const weekendToolTipMessage = "Automate your base weekend rates (Friday & Saturday nights). Base weekend rates will be reflected in your availability calendar.";

    return (<div>
      <Formik onSubmit={this.props.exit ? this.exit : this.onSubmit} initialValues={listing} enableReinitialize={true} validationSchema={ListingPricingSchema}>
        {({ errors, touched, values, setFieldValue, handleChange }) => {

          const isPricingTouched = touched.pricing;
          const isExtendedStayPricingTouched = touched.pricing ? touched.pricing.extended_fee : null;
          const isWeekendStayPricingTouched = touched.pricing ? touched.pricing.weekend_fee : null;
          const isPricingErrors = errors.pricing;
          const isExtendedStayPricingErrors = errors.pricing ? errors.pricing.extended_fee : null;
          const isWeekendStayPricingErrors = errors.pricing ? errors.pricing.weekend_fee : null;

          return (
            <Form>
              <div>
                <section>
                  <h5>Set Default Pricing</h5>
                  <div>
                    Pricing is calculated based on your base fee, plus
                    additional fees, including taxes.You can change your
                    pricing at anytime.
                  </div>
                  <div className="fieldgroup row">
                    <label className="col-6">Base Fee <ToolTip position="right" message={priceToolTipMessage}>
                      <i className="far fa-question-circle"></i></ToolTip></label>
                    <span className="dollar-field col-6">
                      <Field
                        name="pricing.baseFee"
                        type="number"
                        className={`${cssFormControl} ` +
                          (isPricingTouched && isPricingErrors && isPricingErrors['baseFee'] ? cssErrorInput : '')}
                      />
                    </span>
                    <ErrorMessage name="pricing.baseFee" component="div" className="error-message col-12" />
                  </div>
                  {
                    this.renderExtraPricing(
                      values.pricing.weekend_fee, "Weekend Stay Pricing?", "Base Fee per Night (Weekend Stay)", weekendToolTipMessage,
                      "pricing.weekend_fee.enabled", "pricing.weekend_fee.from", "pricing.weekend_fee.to", "pricing.weekend_fee.value",
                      isWeekendStayPricingTouched && isWeekendStayPricingErrors && isWeekendStayPricingErrors['from'],
                      isWeekendStayPricingTouched && isWeekendStayPricingErrors && isWeekendStayPricingErrors['to'],
                      isWeekendStayPricingTouched && isWeekendStayPricingErrors && isWeekendStayPricingErrors['value'],
                      MAGIC_NUMBER.WEEKEND_STAY_MIN_DURATION - 1,
                      handleChange, setFieldValue,
                      (date) => {
                        const day = date.getDay();
                        return day === 5 || day === 6
                      }
                    )
                  }
                  {
                    this.renderExtraPricing(
                      values.pricing.extended_fee, `Extended Stay Pricing (${MAGIC_NUMBER.EXTENDED_STAY_MIN_DURATION}+ Days)?`,
                      "Base Fee per Night (Extended Stay)", extendedStayToolTipMessage,
                      "pricing.extended_fee.enabled", "pricing.extended_fee.from", "pricing.extended_fee.to", "pricing.extended_fee.value",
                      isExtendedStayPricingTouched && isExtendedStayPricingErrors && isExtendedStayPricingErrors['from'],
                      isExtendedStayPricingTouched && isExtendedStayPricingErrors && isExtendedStayPricingErrors['to'],
                      isExtendedStayPricingTouched && isExtendedStayPricingErrors && isExtendedStayPricingErrors['value'],
                      MAGIC_NUMBER.EXTENDED_STAY_MIN_DURATION,
                      handleChange, setFieldValue
                    )
                  }
                  <div className="fieldgroup row">
                    <label className="col-6">Cleaning Fee</label>
                    <span className="dollar-field col-6">
                      <Field
                        name="pricing.cleaningFee"
                        type="number"
                        className={`${cssFormControl} ` +
                          (isPricingTouched && isPricingErrors && isPricingErrors['cleaningFee'] && isPricingErrors['cleaningFee'] ? cssErrorInput : '')} />
                    </span>
                    <ErrorMessage name="pricing.cleaningFee" component="div" className="error-message col-12" />
                  </div>
                  <div className="fieldgroup row">
                    <label className="col-6">Pet Fee</label>
                    <span className="dollar-field col-6">
                      <Field
                        name="pricing.petFee"
                        type="number"
                        className={`${cssFormControl} ` +
                          (isPricingTouched && isPricingErrors && isPricingErrors['petFee'] && isPricingErrors['petFee'] ? cssErrorInput : '')} />
                    </span>
                    <ErrorMessage name="pricing.petFee" component="div" className="error-message col-12" />
                  </div>
                  <div className="fieldgroup row">
                    <label className="col-6">Minimum Night Stay</label>
                    <PlusMinusNumber
                      name="pricing.minNightStay"
                      num={listing.pricing.minNightStay}
                      className="field-control col-6"
                      incrementBy="1"
                      callBack={this.numberChange}
                      minValue="1" />
                  </div>
                  <div className="fieldgroup row">
                    <label className="col-6">Security Deposit <ToolTip position="right" message={depositToolTipMessage}>
                      <i className="far fa-question-circle"></i></ToolTip></label>
                    <span className="dollar-field col-6">
                      <Field
                        name="pricing.deposit"
                        type="number"
                        className={`${cssFormControl} ` +
                          (isPricingTouched && isPricingErrors && isPricingErrors['deposit'] && isPricingErrors['deposit'] ? cssErrorInput : '')
                        } />
                    </span>
                    <ErrorMessage name="pricing.deposit" component="div" className="error-message col-12" />
                  </div>
                </section>
                <section>
                  <h5>Taxes</h5>
                  <div>
                    We recommend researching both the local and state tax
                    rules that apply to your listing. This combined percentage
                    will be automatically applied to bookings. This can be managed
                    and updated via your owner dashboard.
                  </div>
                  <div className="fieldgroup row">
                    <label className="col-6">Local Tax</label>
                    <span className="percent-field col-6">
                      <Field
                        name="pricing.localTaxDecimal"
                        type="number"
                        min="0"
                        max="100"
                        step="0.01"
                        className={cssFormControl} />
                    </span>

                  </div>
                  <div className="fieldgroup row">
                    <label className="col-6">State Tax</label>
                    <span className="percent-field col-6">
                      <Field
                        name="pricing.stateTaxDecimal"
                        type="number"
                        min="0"
                        max="100"
                        step="0.01"
                        className={cssFormControl} />
                    </span>

                  </div>
                </section>
                {this.props.workflow !== 'edit' && (
                  <section className="discounts-container">
                    <ListingDiscountComponent
                      values={values}
                      onDiscountRemove={(discount, values) => removeDiscount(discount, values, this.props)}
                      onDiscountEdit={this.openDiscountModal}
                      showExpired={false} />
                  </section>
                )}
              </div>
              <div className="button-row row">
                <div className="col-4">
                  <label className="float-left" onClick={() => { this.submitAndBack(values) }}>Back</label>
                </div>
                <div className="col-8">
                  <div className="row">
                    <div className="col-md-6 col-12">
                      {this.props.workflow !== "edit" &&
                        <label className="float-right" onClick={() => { this.submitAndExit(values) }}>Save & Finish Later</label>
                      }
                    </div>
                    <div className="col-md-6 col-12">
                      {this.state.isSubmitting ?
                        <button className="btn-primary float-right" disabled={true} onClick={() => { }}>Saving...</button> :
                        <button className="btn-primary float-right" type="submit">
                          {submitButtonText}
                        </button>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          )
        }}
      </Formik>
      {discountModalOpen && (<DiscountModal onClose={this.closeDiscountModal}
        onSubmit={(discountValues) => { submitDiscount(discountValues, listing, this.props, this.closeDiscountModal) }} discount={editingDiscount} />)}
    </div>
    )
  }

}

export default withRouter(connect(mapStateToProps)(ListingFormPricing));
